import React, { useState, useEffect } from 'react';
import './ViolationDescriptionManager.css';
import { API_BASE_URL } from '../../api/apiClient';

const ViolationDescriptionManager = () => {
  const [descriptions, setDescriptions] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingViolation, setEditingViolation] = useState(null);
  const [editedDescription, setEditedDescription] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    fetchDescriptions();
  }, []);

  const fetchDescriptions = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_BASE_URL}/api/violation-descriptions`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch violation descriptions');
      }
      
      const data = await response.json();
      setDescriptions(data);
    } catch (err) {
      console.error('Error fetching descriptions:', err);
      setError('Failed to load violation descriptions. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (violationName) => {
    setEditingViolation(violationName);
    setEditedDescription(descriptions[violationName] || '');
    setSuccessMessage('');
  };

  const handleCancel = () => {
    setEditingViolation(null);
    setEditedDescription('');
    setSuccessMessage('');
  };

  const handleSave = async () => {
    if (!editingViolation) return;
    
    try {
      const response = await fetch(`${API_BASE_URL}/api/update-violation-description`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          violationName: editingViolation,
          description: editedDescription
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update description');
      }

      const result = await response.json();
      
      // Update local state with the new description
      setDescriptions({
        ...descriptions,
        [editingViolation]: editedDescription
      });
      
      setEditingViolation(null);
      setEditedDescription('');
      setSuccessMessage(`Description for "${editingViolation}" updated successfully!`);
      
      // Clear success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (err) {
      console.error('Error updating description:', err);
      setError('Failed to update description. Please try again.');
    }
  };

  const handleDescriptionChange = (e) => {
    setEditedDescription(e.target.value);
  };

  if (isLoading) {
    return <div className="loading">Loading violation descriptions...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="violation-descriptions-manager">
      <h2>Manage Violation Descriptions</h2>
      
      {successMessage && (
        <div className="success-message">{successMessage}</div>
      )}
      
      <div className="descriptions-list">
        {Object.entries(descriptions).map(([violationName, description]) => (
          <div key={violationName} className="description-item">
            <div className="violation-name">{violationName}</div>
            
            {editingViolation === violationName ? (
              <div className="edit-container">
                <textarea 
                  value={editedDescription} 
                  onChange={handleDescriptionChange}
                  rows={3}
                  className="description-editor"
                />
                <div className="edit-actions">
                  <button className="save-btn" onClick={handleSave}>Save</button>
                  <button className="cancel-btn" onClick={handleCancel}>Cancel</button>
                </div>
              </div>
            ) : (
              <>
                <div className="description-text">{description}</div>
                <button className="edit-btn" onClick={() => handleEdit(violationName)}>
                  Edit
                </button>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ViolationDescriptionManager; 